import { v4 as uuidv4 } from "uuid";
import { useSelectedNotebookPageIdMap } from "../../page";
import { useAppIdMap } from "../../app";
import { useInsertBlock } from "../block";
import { useAddVolumes } from "../../volume";
import { newVolume } from "../../../types/volume";
import { VolumeBlock } from "../../../types/notebook/note/block/volume";
import { writeData } from "../../../api";
import { insertPageBlock } from "../../../api/page";

export const useInsertVolumeBlock = () => {
  const { selectedNotebookPageId } = useSelectedNotebookPageIdMap();
  const { appId } = useAppIdMap();
  const insertBlock = useInsertBlock();
  const addVolumes = useAddVolumes();
  return async (config: { blockIndex: number }) => {
    const { blockIndex } = config;
    const volumeId = uuidv4();
    const vol = newVolume({ appId: appId!, volumeId, name: "Volume" });
    const block: VolumeBlock = {
      "block-id": uuidv4(), "app-id": appId!, "volume-id": volumeId,
      type: "omega/query-omega/page/block/volume/VolumeBlock",
      "page-id": selectedNotebookPageId!,
    };
    addVolumes([vol]);
    insertBlock({ block, blockIndex });
    await writeData(vol);
    await insertPageBlock({ block, "block-index": blockIndex });
    return block;
  };
};
